import { useMedia } from 'react-use'
import { useTheme } from 'styled-components'

export const useMediaDesktopSmallMaxWidth = () => {
  const theme = useTheme()
  const match = useMedia(theme.desktopSmall.queryMaxWidth, false)
  return match
}
